import { render, staticRenderFns } from "./NeonatusMortalityReport.vue?vue&type=template&id=6d66d26a&scoped=true"
import script from "./NeonatusMortalityReport.vue?vue&type=script&lang=js"
export * from "./NeonatusMortalityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66d26a",
  null
  
)

export default component.exports